__webpack_require__.p = "/reports-component-actions-data/account-setup/";